import { render, staticRenderFns } from "./LKPublicationsCardRecommendationRpshV3MassGeneration.vue?vue&type=template&id=3848410b&"
import script from "./LKPublicationsCardRecommendationRpshV3MassGeneration.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsCardRecommendationRpshV3MassGeneration.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsCardRecommendationRpshV3MassGeneration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDataTable,VProgressLinear,VSelect,VTextField})
